module.exports = __webpack_public_path__ + "static/img-main-f57513a0f18129cb16158f512679ded5.jpg";